"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as e } from "react/jsx-runtime";
import { useTheme as n } from "../../hooks.js";
import { useIsInverseVariant as m } from "../../theme-variant-context.js";
import { vars as c } from "../../skins/skin-contract.css-mistica.js";
const a = (_param)=>{
    var { color: i, size: l = 24 } = _param, o = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const h = m(), r = i !== null && i !== void 0 ? i : h ? c.colors.inverse : c.colors.neutralHigh, { skinName: t } = n();
    return t.match(/^o2-new/i) ? /* @__PURE__ */ e("svg", _object_spread_props(_object_spread({
        width: l,
        height: l,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, o), {
        children: /* @__PURE__ */ e("path", {
            fill: r,
            d: "M12 2 3.5 7.097v9.802L12 22l8.5-5.097V7.097zm0 9.177L9.307 9.63l6.392-3.74 2.698 1.615zm-4.125-2.37L5.603 7.507 12 3.67l2.298 1.38zm-2.956-.045 6.374 3.657v7.483L4.919 16.08zm7.788 3.657 6.374-3.657v7.318l-6.374 3.823z"
        })
    })) : t.match(/^o2/i) ? /* @__PURE__ */ e("svg", _object_spread_props(_object_spread({
        width: l,
        height: l,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, o), {
        children: /* @__PURE__ */ e("path", {
            fill: r,
            d: "M12 2 3.5 7.097v9.802L12 22l8.5-5.097V7.097zm0 9.177L9.307 9.63l6.392-3.74 2.698 1.615zm-4.125-2.37L5.603 7.507 12 3.67l2.298 1.38zm-2.956-.045 6.374 3.657v7.483L4.919 16.08zm7.788 3.657 6.374-3.657v7.318l-6.374 3.823z"
        })
    })) : /* @__PURE__ */ e("svg", _object_spread_props(_object_spread({
        width: l,
        height: l,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, o), {
        children: /* @__PURE__ */ e("path", {
            fill: r,
            d: "M21.802 8.21a.5.5 0 0 1 .011.23c.017.09.031.18.034.28v11.447c0 .925-.818 1.678-1.826 1.678H3.989c-1.009 0-1.826-.753-1.826-1.678V8.72c0-.162.03-.316.078-.465l.001-.02q0-.009.002-.019l1.333-4.739c.048-.734.77-1.32 1.653-1.32h13.547c.88 0 1.6.583 1.653 1.317zm-2.82-4.652c0-.098-.093-.173-.207-.176H14.11l.462 3.655h5.397l-.966-3.333a.4.4 0 0 1-.022-.146m-13.96 0a.5.5 0 0 1-.02.143l-.94 3.339h5.041l.387-3.655H5.23c-.115 0-.208.078-.208.173M20.015 20.61c.202 0 .378-.21.378-.448V8.715c0-.238-.176-.449-.378-.449h-5.36l.002 2.462c0 .34-.325.614-.725.614h-4.18c-.4 0-.725-.275-.725-.614V8.266H3.983c-.202 0-.375.21-.375.449v11.447c0 .238.173.448.375.448zM13.21 8.266h-2.73v1.846h2.73zm-.092-1.23-.465-3.649H10.94l-.387 3.65z"
        })
    }));
}, d = a;
export { d as default };
